function changeTimezone(date, ianatz) {
  var invdate = new Date(date.toLocaleString("en-US", { timeZone: ianatz }));
  var diff = date.getTime() - invdate.getTime();
  return new Date(date.getTime() - diff);
}

jQuery(function ($) {
  var $button = $(".desireDateButton");
  if (!$button.length) {
    return;
  }

  // Initialize the picker as soon as the DOM is ready (not on window "load"
  // + AJAX), so the "Desired Delivery Date" button responds on the very first
  // click/tap and keeps working even if the date-config request is slow/fails.
  $button.flatpickr({
    minDate: "today",
    dateFormat: "Y-m-d",
    // Use flatpickr's own touch-friendly calendar on every device, including
    // iPhone/iOS. Native mobile mode opens via setTimeout(...mobileInput.click)
    // which iOS blocks outside a synchronous gesture, so the button needed a
    // second tap (or never opened). The JS calendar opens on the first tap.
    disableMobile: true,
    onChange: function (selectedDates, dateStr) {
      $(".desireDate").val(dateStr);
      $(".desireDateButton").text(dateStr).css("border-color", "black");
    }
  });

  var picker = $button[0]._flatpickr;

  // Guarantee a single click/tap opens the picker across every device and
  // input method (mouse, trackpad, touch, keyboard). open() is idempotent
  // (no-ops when already open, never closes), so this is purely additive and
  // cannot cause a close/toggle regression.
  $(document).on("click", ".desireDateButton", function () {
    if (picker) {
      picker.open();
    }
  });

  // Load the blackout dates / requirement flag and apply them to the live
  // picker. This no longer gates whether the button is clickable.
  $.ajax({
    url: "https://hwtshopifyapp.com/date-picker/date",
    dataType: "json",
    success: function (resp) {
      if (resp.date_status == "0") {
        $(".SwymDatePicker").hide();
        $(".desireDate").attr("required", false);
      } else {
        $(".SwymDatePicker").show();
        $(".desireDate").attr("required", true);
      }

      var dates = [];
      var pstTime = changeTimezone(new Date(), "America/Los_Angeles");
      var hours = pstTime.getHours();

      var day = pstTime.getDate() + "";
      if (day.length < 2) {
        day = "0" + day;
      }
      var month = (pstTime.getMonth() + 1) + "";
      if (month.length < 2) {
        month = "0" + month;
      }
      var time = pstTime.getFullYear() + "-" + month + "-" + day;

      for (var i = 0; i < resp.date_picker.length; i++) {
        dates[i] = resp.date_picker[i].dis_date;
      }
      if (hours >= "11") {
        dates.push(time);
      }

      if (picker) {
        picker.set("disable", dates);
      }
    }
  });
});

$(document).on("change", ".desireDateButton", function () {
  if ($(".desireDate").val()) {
    $("#AddToCart").removeClass("addtocart_disabled");
    $("#AddToCart").show();
    $(".addtocart_disabled").hide();
    $(".SwymDatePicker").removeClass("fillthisdate");
  } else {
    $("#AddToCart").addClass("addtocart_disabled");
    $("#AddToCart").hide();
    $(".addtocart_disabled").show();
  }
});

$(document).on("click", ".addtocart_disabled", function (e) {
  e.preventDefault();
  if ($(".desireDate").val().length === 0) {
    alert("Please allow popups on this page to select date");
    $(".SwymDatePicker").addClass("fillthisdate");
  } else {
    $(".SwymDatePicker").removeClass("fillthisdate");
  }
});
